module.exports = __webpack_public_path__ + "img/genshin.a699a6b.jpg";